/* eslint-disable jsx-a11y/no-static-element-interactions */
import React from 'react';
import PropTypes from 'prop-types';
import { SimpleFlexbox, Icon } from 'ctm-components';
import { SimpleSelect } from '../form/simple_select/simple_select';
import styles from './non_std_accessories.css';

/**
 * Builds an array of option elements form options array
 * @param {Object} props - component's props
 * @param {String} props.code - accessory's code
 * @param {String} props.label - the accessory label
 * @param {Function} props.onRemove - The function to fire when the delete icon is clicked
 * @returns {Node} Returns the SelectedNonStdAccessory component
 */
const SelectedNonStdAccessory = ({ code, label, onRemove }) => {
    return (
        <SimpleFlexbox display="flex" className={styles.added_accessory}>
            <div className={styles.selected_option}>
                <Icon className={styles.accessories_tick} variant="ctm_skinny_tick" />
                {' '}
                {label}
            </div>
            <div className={styles.added_accessory_options_container}>
                <div className={styles.delete_btn} onClick={() => onRemove({ code })}>
                    <Icon variant="ctm_cross" />
                </div>
            </div>
        </SimpleFlexbox>
    );
};

SelectedNonStdAccessory.propTypes = {
    onRemove: PropTypes.func.isRequired,
    label: PropTypes.string.isRequired,
    code: PropTypes.string.isRequired
};

export { SelectedNonStdAccessory };
